import type { IMoney } from "@jti/magento";

import { useCheckoutV2Configuration } from "@checkout-v2/shared";
import { useCartPrices } from "@checkout-v2/shared/hooks/useCartPrices";

type DiscountDisclaimerState = {
  minimumPayableAmount?: IMoney;
  warningMessageTemplate?: string;
  disclaimerMessageTemplate?: string;
  shouldShowWarning: boolean;
  shouldShowDisclaimer: boolean;
};

export const useDiscountDisclaimer = (): DiscountDisclaimerState => {
  const { discountDisclaimer } = useCheckoutV2Configuration();
  const { data: prices } = useCartPrices();
  const minimumPayableAmount = prices?.minimumPayableAmount;
  const isMinimumPayableAmountEnabled = Boolean(minimumPayableAmount?.value && minimumPayableAmount?.value !== 0);

  const shouldShowWarning = isMinimumPayableAmountEnabled && !!discountDisclaimer?.warningMessage;

  const shouldShowDisclaimer = discountDisclaimer.enabled;

  return {
    minimumPayableAmount,
    warningMessageTemplate: discountDisclaimer?.warningMessage,
    disclaimerMessageTemplate: discountDisclaimer?.enabled ? discountDisclaimer.disclaimerMessage : undefined,
    shouldShowWarning,
    shouldShowDisclaimer,
  };
};
